import { useStandardProductDeliveryCostsCalculator } from "app/hooks/shared/standard-product/useStandardProductDeliveryCostsCalculator";
import { useStandardProductType } from "app/hooks/shared/standard-product/useStandardProductType";
import { useCartContext } from "app/providers/CartProvider";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

const CheckoutDeliveryPricesInfoBlock = () => {
  const { getCart } = useCartContext();
  const cart = getCart();
  const productAnalysis = useStandardProductType(cart);

  // Only show the montoren block when there are no AccessoireAkoestischPaneel products in the cart
  const showMonterenBlock =
    !productAnalysis.someAccessoireAkoestischPaneel ||
    productAnalysis.someAkoestischepanelen;

  const { standardProductDeliveryCosts, standardProductAssemblyCosts } =
    useStandardProductDeliveryCostsCalculator(cart, true);

  const standardProductDeliveryPrice = getFormattedPrice(
    standardProductDeliveryCosts,
  );
  const standardProductAssemblyPrice = getFormattedPrice(
    standardProductAssemblyCosts,
  );

  return (
    <section className="gg-grid gg-rounded-sm gg-bg-grey-500 gg-px-5 gg-py-9 gg-text-dark-blue xl:gg-px-9">
      <div>
        {/* Title */}
        <h3 className="gg-text-lg gg-font-bold md:gg-text-xl">
          Extra diensten (optioneel)
        </h3>

        {/* Prices detailed */}
        <div className="gg-mt-5 gg-grid gg-w-full gg-grid-cols-3 gg-gap-y-2.5 gg-text-sm md:gg-text-base">
          <h5 className="gg-col-span-2">Thuis laten bezorgen:</h5>

          <p className="gg-font-bold">{standardProductDeliveryPrice}</p>

          {showMonterenBlock && (
            <>
              <h5 className="gg-col-span-2">
                Thuis laten bezorgen en monteren:
              </h5>
              <p className="gg-font-bold">{standardProductAssemblyPrice}</p>
            </>
          )}
        </div>

        {/* Description */}
        <p className="gg-mt-8 gg-text-sm gg-leading-7 md:gg-text-base">
          Het afhalen van je bestelling is altijd{" "}
          <span className="gg-font-bold">gratis</span>. Dit kan bij ons op
          locatie in <span className="gg-font-bold">Amsterdam</span> of{" "}
          <span className="gg-font-bold">Vlaardingen</span>. Maak je keuze bij{" "}
          <span className="gg-font-bold">Stap 3</span>.
        </p>
      </div>
    </section>
  );
};
export default CheckoutDeliveryPricesInfoBlock;
